import { render, staticRenderFns } from "./CardPerformaDashboard.vue?vue&type=template&id=14d35840&scoped=true"
import script from "./CardPerformaDashboard.vue?vue&type=script&lang=js"
export * from "./CardPerformaDashboard.vue?vue&type=script&lang=js"
import style0 from "./CardPerformaDashboard.vue?vue&type=style&index=0&id=14d35840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d35840",
  null
  
)

export default component.exports